module.exports = __webpack_public_path__ + "static/media/K5.59f2e49c.jpg";